interface PlaceholderValues {
  make?: string;
  model?: string;
}

const getMakeModelBoldText = (value: string, isBold: boolean) => {
  if (!value) return "";
  if (!isBold) return value;

  return `<b>${value}</b>`;
};

const replaceMakeModelPlaceholders = (template: string, values: PlaceholderValues, isBold?: boolean): string => {
  return template
    .replace(/\{make\}/g, getMakeModelBoldText(values.make, isBold))
    .replace(/\{model\}/g, getMakeModelBoldText(values.model, isBold))
    .replace(/\s+/g, " ")
    .trim();
};

export { replaceMakeModelPlaceholders };
